<app-add-callback-modal [entity]='this.currentAccount'></app-add-callback-modal>
<app-grid
entity='account'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
